module.exports = __webpack_public_path__ + "static/img/googleplay_dark.345d9a08.png";